module.exports = __webpack_public_path__ + "img/joinDotStraightWhite.2e5004f6.svg";